"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aclTranslationsEn = void 0;
exports.aclTranslationsEn = {
    // ACL Resources
    'acl_resource.company': 'Company',
    'acl_resource.user': 'User',
    'acl_resource.user_group': 'User Group',
    'acl_resource.settings_general': 'General Settings',
    'acl_resource.settings_access': 'Access Settings',
    'acl_resource.settings_styles': 'Style Settings',
    'acl_resource.avatar': 'Avatar',
    'acl_resource.ai': 'AI',
    'acl_resource.knowledge': 'Knowledge',
    'acl_resource.project': 'Project',
    'acl_resource.onboarding': 'Onboarding',
    'acl_resource.reports': 'Reports',
    // ACL Actions
    'acl_action.read': 'Read',
    'acl_action.write': 'Write',
    'acl_action.delete': 'Delete',
};
